module.exports = __webpack_public_path__ + "static/bertens-profile-fad496c0ed11e11b9d711d965ed611c1.jpg";